import React, { useState, useEffect } from "react";
import { IonButtons, IonRange, IonToolbar, IonTitle, IonButton, IonContent, IonModal, IonCol } from '@ionic/react';
import { Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft, faEraser, faArrowsLeftRight, faChevronLeft, faTrash, faArrowUp, faUpDownLeftRight, faCopy, faEyeDropper, faFill, faPlusMinus } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
// import { SketchPicker } from 'react-color'
import { faVacuum } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip } from 'antd';
import IconButton from "../IconButton";
import { HexColorPicker } from "react-colorful";
import { t } from "../../../../i18n";
import "./ToolBar.css"


// make a react component for toolbar that inherits state from parent component
const ToolBar = ({ colors,
    layerSelected,
    setColors,
    setLayerSelected,
    setToolSelected,
    setToolbarState,
    svg,
    toolSelected,
    toolbarState,
    updateSvg,
    radius,
    setRadius
}) => {
    const [dragging, setDragging] = useState(false);
    useEffect(() => {
    }, [toolSelected]);



    return (

        <>
            {toolbarState === "default" && (
                <>
                    <Row justify='center' style={{ paddingTop: "5px", paddingBottom: '40px', width: "100%" }}>
                        {layerSelected === "all" && (
                            <IonButtons text >
                                {t("Select a layer to edit")}
                                {/* arrow up icon */}
                                <FontAwesomeIcon icon={faArrowUp} size={14} style={{ padding: "9px" }} />
                            </IonButtons>
                        )}
                        {layerSelected !== "all" && (
                            <ion-scroll
                                class="toolbarDiv"
                                style={{ maxWidth: "100%", overflowX: "scroll", overflowY: "hidden", }}>
                                <Row wrap={false} style={{ paddingLeft: "10px", paddingRight: "10px" }} >
                                    <IconButton onClickHandler={() => { setToolSelected("move") }} isSelected={toolSelected === 'move' ? true : false} icon={faUpDownLeftRight} text={t("Pan")} />
                                    <IconButton onClickHandler={() => { setToolSelected("cut") }} icon={faPlusMinus} text={t("Fill-Cut")} textSize="small" isSelected={toolSelected === 'cut' ? true : false} />
                                    <IconButton onClickHandler={() => { setToolSelected("erase"); setToolbarState("erase") }} icon={faEraser} text={t("Erase")} isSelected={toolSelected === 'erase' ? true : false} />
                                    <IconButton onClickHandler={() => { setToolSelected("vacuum"); setToolbarState("vacuum") }} icon={faVacuum} text={t("Vacuum")} isSelected={toolSelected === 'vacuum' ? true : false} />
                                    <IconButton onClickHandler={() => {
                                        let largestBox = 0;
                                        let largestBoxIndex = 0;
                                        let svgCopy = JSON.parse(JSON.stringify(svg));
                                        let index = layerSelected;
                                        let layer = svgCopy.children[index];
                                        for (let i = 0; i < layer.children.length; i++) {
                                            let box = layer.children[i].width * layer.children[i].height;
                                            if (box > largestBox) {
                                                largestBox = box;
                                                largestBoxIndex = i;
                                            }
                                        }
                                        layer.children.splice(0, largestBoxIndex);
                                        layer.children.splice(1, layer.children.length - 1);
                                        updateSvg(svgCopy);
                                    }} icon={faFill} text={t("Auto-Fill")} />
                                    <MyColorPicker svg={svg} updateSvg={updateSvg} colors={colors} layerSelected={layerSelected} setColors={setColors} />
                                    <IconButton onClickHandler={() => { setToolbarState("reorder") }} icon={faArrowsLeftRight} text={t("Order")} isSelected={toolSelected === 'reorder' ? true : false} />
                                    <IconButton onClickHandler={() => {
                                        // Make a shallow copy of the item you want to mutate
                                        var svgCopy = JSON.parse(JSON.stringify(svg));
                                        // get the index of the selected layer
                                        let index = layerSelected;
                                        // duplicate the layer in svgCopy.children
                                        svgCopy.children.splice(index, 0, svgCopy.children[index]);
                                        // set the svg to the new svg
                                        updateSvg(svgCopy);
                                        //  add to the colors array
                                        var colorsCopy = JSON.parse(JSON.stringify(colors));
                                        colorsCopy.splice(index, 0, colorsCopy[index]);
                                        setColors(colorsCopy);
                                    }} icon={faCopy} text={t("Copy")} isSelected={toolSelected === 'duplicate' ? true : false} />

                                    <IconButton onClickHandler={() => {
                                        // Make a shallow copy of the item you want to mutate
                                        let svgCopy = JSON.parse(JSON.stringify(svg));
                                        // get the index of the selected layer
                                        let index = layerSelected;
                                        // delete the layer in svgCopy.children
                                        svgCopy.children.splice(index, 1);
                                        // set the svg to the new svg
                                        updateSvg(svgCopy);
                                        // set the layer selected to the layer above it
                                        setLayerSelected("all");
                                        // remove from the colors array
                                        let colorsCopy = JSON.parse(JSON.stringify(colors));
                                        colorsCopy.splice(index, 1);
                                        setColors(colorsCopy);
                                    }} icon={faTrash} text={t("Delete")} />

                                </Row>
                            </ion-scroll>
                        )}
                    </Row>
                </>
            )}

            {toolbarState === "reorder" && (
                <Row>
                    <Col flex="100px">
                        <Row justify='center' onClick={() => { setToolbarState("default") }} style={{
                            paddingTop: "5px", paddingBottom: '40px', width: "100%"
                        }}>
                            <IconButton icon={faChevronLeft} text="" />
                        </Row>

                    </Col>
                    <Col flex="auto">
                        <Row justify='center' style={{ paddingTop: "5px", paddingBottom: '40px', width: "calc(100%)", marginLeft: "-50px" }}>
                            <IconButton disabled={layerSelected === 0} icon={faArrowLeft} text=""
                                onClickHandler={() => {
                                    // Make a shallow copy of the item you want to mutate
                                    let svgCopy = JSON.parse(JSON.stringify(svg));
                                    // get the index of the selected layer
                                    let index = layerSelected;
                                    // if the index is not 0
                                    if (index !== 0) {
                                        // swap the layer with the layer above it for svgCopy.children
                                        [svgCopy.children[index], svgCopy.children[index - 1]] = [
                                            svgCopy.children[index - 1],
                                            svgCopy.children[index],
                                        ];
                                        // set the svg to the new svg
                                        updateSvg(svgCopy);
                                        // set the layer selected to the layer above it
                                        setLayerSelected(index - 1);

                                        // remove from the colors array
                                        let colorsCopy = JSON.parse(JSON.stringify(colors));
                                        [colorsCopy[index], colorsCopy[index - 1]] = [
                                            colorsCopy[index - 1],
                                            colorsCopy[index],
                                        ];
                                        setColors(colorsCopy);
                                    }
                                }}
                            />

                            <IconButton disabled={layerSelected === svg.children.length - 1} icon={faArrowRight} text=""
                                onClickHandler={() => {
                                    // Make a shallow copy of the item you want to mutate
                                    let svgCopy = JSON.parse(JSON.stringify(svg));
                                    // get the index of the selected layer
                                    let index = layerSelected;

                                    // if the index is not the last index
                                    if (index !== svgCopy.children.length - 1) {
                                        // swap the layer with the layer below it for svgCopy.children
                                        [svgCopy.children[index], svgCopy.children[index + 1]] = [
                                            svgCopy.children[index + 1],
                                            svgCopy.children[index],
                                        ];
                                        // set the svg to the new svg
                                        updateSvg(svgCopy);
                                        // set the layer selected to the layer above it
                                        setLayerSelected(index + 1);
                                    }
                                }}
                            />
                        </Row>
                    </Col>
                </Row>
            )}

            {toolbarState === "vacuum" && (
                <Row>
                    {/* <Row  style={{ paddingTop: "5px", paddingBottom: '40px', width: "calc(50px)" }}></Row> */}
                    <Col flex="100px">
                        <Row justify='center' onClick={() => { setToolbarState("default"); setToolSelected("move") }} style={{
                            paddingTop: "5px", paddingBottom: '40px', width: "100%"
                        }}>
                            <IconButton icon={faChevronLeft} text="" />
                        </Row>

                    </Col>
                    <Col flex="auto">
                        <Tooltip
                            title={
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.3)"
                                }}>
                                    <svg width={radius} height={radius} style={{ backgroundColor: "white" }}>
                                        <rect width={radius * 2} height={radius * 2} fill="white" />
                                    </svg>
                                </div>
                            }
                            placement="top"
                            arrow={false}
                            // make the tooltip background to light grey
                            style={{ backgroundColor: 'transparent' }}
                            // open tooltip when IonRange is being dragged
                            open={dragging}
                            // set dragging to false when clicked off of the slider
                            onClose={() => {
                                setDragging(false);
                            }}
                        >
                            <IonRange
                                onBlur={() => { setDragging(false); }}
                                style={{ marginTop: "-5px", maxWidth: "calc(100% - 100px)", }}
                                min={10}
                                max={100}
                                step={1}
                                value={radius}
                                onIonChange={e => {
                                    // setEraseSize(e.detail.value);
                                    setRadius(e.detail.value);
                                    // set dragging to true when the slider is being dragged
                                    setDragging(true);
                                }}>
                                <FontAwesomeIcon slot="start" icon={faVacuum} size="xs" />
                                <FontAwesomeIcon slot="end" icon={faVacuum} />
                            </IonRange>
                        </Tooltip>
                    </Col>
                </Row>
            )}

            {toolbarState === "erase" && (
                <Row>
                    <Col flex="100px">
                        <Row justify='center' onClick={() => { setToolbarState("default"); setToolSelected("move") }} style={{
                            paddingTop: "5px", paddingBottom: '40px', width: "100%"
                        }}>
                            <IconButton icon={faChevronLeft} text="" />
                        </Row>

                    </Col>
                    <Col flex="auto">
                        <Tooltip
                            title={

                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.3)"
                                }}>
                                    <svg width={radius} height={radius} style={{ backgroundColor: "white" }}>
                                        <rect width={radius * 2} height={radius * 2} fill="white" />
                                    </svg>
                                </div>

                            }
                            placement="top"
                            arrow={false}
                            open={dragging}
                            onClose={() => {
                                setDragging(false);
                            }}
                        >


                            <IonRange
                                onBlur={() => { setDragging(false); }}
                                style={{ marginTop: "-5px", maxWidth: "calc(100% - 100px)", }}
                                min={10}
                                max={100}
                                step={1}
                                value={radius}
                                onIonChange={async (e) => {
                                    setRadius(e.detail.value);
                                    setDragging(true);
                                }}>
                                <FontAwesomeIcon slot="start" icon={faEraser} size="xs" />
                                <FontAwesomeIcon slot="end" icon={faEraser} />
                            </IonRange>
                        </Tooltip>

                        {/* </Row> */}
                    </Col>
                </Row>
            )}
        </>
    )
}

class MyColorPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            color: props.colors[props.layerSelected]
        };
    }

    handleChangeComplete = (color) => {
        this.setState({ color: color.hex });
    }

    render() {
        return (
            <>
                <IconButton onClickHandler={() => {
                    this.setState({ showModal: true })


                }} icon={faEyeDropper} text={t("Color")} />

                <IonModal isOpen={this.state.showModal}
                    onDidDismiss={() => this.setState({ showModal: false })}
                    style={{ '--height': "450px" }}
                >
                    <IonToolbar>
                        <IonTitle>{t("Set Color")}</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={() => this.setState({ showModal: false })}>{t("Close")}</IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent className="ion-padding" style={{ margin: "15px" }}>

                        <IonCol>
                            <center>
                                <HexColorPicker color={this.state.color} onChange={(color) => this.setState({ color: color })} style={{ width: "90%", }} />
                                <Row style={{ paddingTop: "10px", width: "90%",
                            // make the overflow hidden so that the colors don't go out of the box
                            overflow: "hidden"
                            }}>
                                {/* <div
                       
                                style={{ overflowX: "scroll", width: "100%" }}> */}
                                
                                    {/* map color in colors */}
                                    {this.props.colors.map((color, index) => {
                                        return (
                                            <div style={{ marginRight: "5px", paddingTop: "20px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: color, width: "35px", height: "35px" }} onClick={() => { this.setState({ color: color }) }}></div>
                                        )
                                    })}
                                    {/* </div> */}
                                </Row>
                            </center>
                        </IonCol>
                        <IonButton color="secondary" expand="block" key="back" onClick={() => {
                            // create a soft copy of the colors array
                            let colorsCopy = JSON.parse(JSON.stringify(this.props.colors));
                            // set the color of the selected layer to the color selected
                            colorsCopy[this.props.layerSelected] = this.state.color;
                            // set the colors array to the new colors array
                            this.props.setColors(colorsCopy);
                            let svgCopy = JSON.parse(JSON.stringify(this.props.svg));
                            svgCopy.children[this.props.layerSelected].attributes.fill = this.state.color;
                            this.props.updateSvg(svgCopy);
                            // close the modal
                            this.setState({ showModal: false });

                        }} >
                            {t("Save")}
                        </IonButton>
                    </IonContent>
                </IonModal>
            </>
        );
    }
}

export default ToolBar;